import { render } from "./AmazonShipmentView.vue?vue&type=template&id=3aef7be7&scoped=true"
import script from "./AmazonShipmentView.vue?vue&type=script&lang=js"
export * from "./AmazonShipmentView.vue?vue&type=script&lang=js"

import "./AmazonShipmentView.vue?vue&type=style&index=0&id=3aef7be7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aef7be7"]])

export default __exports__